import { render, staticRenderFns } from "./BankingAccounts.handler.vue?vue&type=template&id=c41d63fa&"
import script from "./BankingAccounts.handler.vue?vue&type=script&lang=ts&"
export * from "./BankingAccounts.handler.vue?vue&type=script&lang=ts&"
import style0 from "./BankingAccounts.handler.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports